document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.wt-product__add-to-cart_form');
    const formThreshold = document.querySelector('.product-form-threshold');
    
    if(!form || !formThreshold) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if(!entry.isIntersecting) {
                form.classList.add('is-fixed-to-bottom')
            } else {
                form.classList.remove('is-fixed-to-bottom');
            }
        });
    }, {
        threshold: 0
    });
    
    observer.observe(formThreshold);
});
